import styled from 'styled-components';

const Container = styled.div`
  cursor: pointer;
`;

export { Container };
